<template>
  <BasePageContainer class="notifications">
    <div
      v-if="hasNoTagFilterConditions"
      class="notifications__no-filter-conditions">
      <button
        class="notifications__tag-tune-btn"
        :class="{ 'notifications__tag-tune-btn--active': showTagSettingsModal }"
        @click="openTagSettings">
        <span class="material-icons notifications__tag-tune-btn-icon">tune</span>
      </button>
      <div class="d-inline-block">
        絞り込み条件がありません<br>
        このボタンから条件を設定してください
      </div>
    </div>
    <div v-else>
      <div
        v-for="(group, groupIndex) in notificationsByDate"
        :ref="'group-' + groupIndex"
        :key="group.date">
        <hr
          v-if="groupIndex > 0"
          class="notifications__divider">
        <div class="notifications__date-group-header">
          <span class="notifications__date-label">{{ group.date }}</span>
        </div>
        <transition-group
          name="notification-card"
          @after-leave="scrollToNextNotification">
          <template v-for="notification in group.notifications">
            <notification-card
              :ref="notification.id"
              :key="notification.id"
              :notification="notification"
              :lock-goal-option="lockGoalOption"
              :show-comment-icon="isCommentNotificationType(notification.type)"
              @check-read="onCheckRead($event)">
              <notification-card-for-activity-result
                v-if="notification.type === 'activity_result'"
                :notification="notification"
                @click-notification="onClickNotification(notification)" />
              <notification-card-for-comment
                v-else-if="notification.type === 'comment'"
                :notification="notification"
                @click-notification="onClickNotification(notification)" />
              <notification-card-for-event-comment
                v-else-if="notification.type === 'event_comment'"
                :event="eventById[notification.eventComment.event]"
                :notification="notification"
                @click-notification="onClickNotification(notification)" />
              <NotificationCardForMandalaEvaluation
                v-else-if="notification.type === 'mandala_goal_self_evaluation'"
                :notification="notification"
                @click-notification="onClickNotification(notification)" />
              <NotificationCardForMandalaEvaluationComment
                v-else-if="
                  notification.type === 'mandala_goal_self_evaluation_comment'
                "
                :notification="notification"
                @click-notification="onClickNotification(notification)" />
              <NotificationCardForPathActivity
                v-else-if="notification.type === 'path_activity'"
                :notification="notification"
                @click-notification="onClickNotification(notification)" />
              <NotificationCardForPathActivityComment
                v-else-if="notification.type === 'path_activity_comment'"
                :notification="notification"
                @click-notification="onClickNotification(notification)" />
              <template
                v-if="notification.type === 'activity_result'"
                #actions>
                <notification-like-button
                  :notification="notification"
                  @like="onLike"
                  @dislike="onDislike" />
              </template>
              <template
                v-else-if="notification.type === 'event_comment'"
                #actions>
                <notification-card-actions
                  class="mr-2"
                  :event="eventById[notification.eventComment.event]"
                  @attend="
                    attendEvent(eventById[notification.eventComment.event])
                  "
                  @absence="
                    absenceEvent(eventById[notification.eventComment.event])
                  "
                  @cancel="
                    cancelAttendEvent(
                      eventById[notification.eventComment.event],
                    )
                  " />
              </template>
              <template
                v-else-if="notification.type === 'mandala_goal_self_evaluation'"
                #actions>
                <SvgTextButton
                  :src="require('@/assets/images/icon_chart.svg')"
                  @click="
                    $router.push(
                      `/members/${notification.mandalaGoalSelfEvaluation.user.id}/`,
                    )
                  ">
                  チャート
                </SvgTextButton>
              </template>
              <template
                v-else-if="notification.type === 'path_activity'"
                #actions>
                <TextButton
                  @click="
                    $router.push(
                      `/members/${notification.pathActivity.user.id}/profile?pathActivityId=${notification.pathActivity.id}`,
                    )
                  ">
                  <span class="material-icons">edit_document</span>
                  プロフィール
                </TextButton>
              </template>
            </notification-card>
            <div
              v-if="returnNotificationId === notification.id"
              :ref="'continue-from-here-' + notification.id"
              :key="'continue-from-here-' + notification.id"
              class="notifications__continue-from-here">
              ↓ &nbsp;続きはここから
            </div>
          </template>
        </transition-group>
        <div class="notifications__date-actions">
          <button
            v-if="isManager && !isCommentFilterActive"
            class="btn btn-l-blue notifications__btn--like-all"
            @click="onClickLikeAllByDate(group.rawDate)">
            <span class="material-icons">thumb_up</span>
            <span class="notifications__btn-label">all</span>
          </button>
          <button
            class="btn btn-l-blue notifications__btn"
            @click="onClickDeleteNotificationsByDate(group.rawDate)">
            全てを既読
          </button>
        </div>
      </div>
      <infinite-loading
        :identifier="infiniteLoadingKey"
        spinner="circles"
        @infinite="infiniteHandler">
        <div slot="no-more" />
        <div slot="no-results" />
      </infinite-loading>
      <div
        v-if="showEmptyText"
        class="d-flex justify-content-center pt-5"
        style="margin-top: 100px;">
        {{ isTagFilterActive || isCommentFilterActive ? 'この条件に一致する通知はありません' : '通知はありません。' }}
      </div>
    </div>
    <scroll-nav
      v-if="showDateNavigationBar"
      @prev="goToPrevDate"
      @next="goToNextDate" />
    <div
      class="notifications__filter-btns"
      :class="{ 'notifications__filter-btns--hidden': isScrollHidden }">
      <notification-tag-menu
        :open="showTagSettingsModal"
        :tag1="selectedTag1"
        :tag2="selectedTag2"
        @save="onTagMenuSave"
        @close="showTagSettingsModal = false" />
      <button
        class="notifications__tag-tune-btn"
        :class="{ 'notifications__tag-tune-btn--active': showTagSettingsModal }"
        @click="openTagSettings">
        <span class="material-icons notifications__tag-tune-btn-icon">tune</span>
      </button>
      <button
        class="notifications__tag-filter-btn mr-2"
        :class="{ 'notifications__tag-filter-btn--active': isTagFilterActive }"
        @click="toggleTagFilter">
        #絞り込み
      </button>
      <button
        class="notifications__comment-filter-btn"
        :class="{ 'notifications__comment-filter-btn--active': isCommentFilterActive }"
        @click="toggleCommentFilter">
        <span class="material-icons notifications__comment-filter-btn-icon">comment</span>
        コメント
      </button>
    </div>
  </BasePageContainer>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import NotificationCard from '@/components/view/NotificationCard.vue'
import NotificationCardActions from '@/components/view/NotificationCardActions.vue'
import NotificationCardForActivityResult from '@/components/view/NotificationCardForActivityResult.vue'
import NotificationCardForComment from '@/components/view/NotificationCardForComment.vue'
import NotificationCardForEventComment from '@/components/view/NotificationCardForEventComment.vue'
import NotificationCardForMandalaEvaluation from '@/components/view/NotificationCardForMandalaEvaluation.vue'
import NotificationCardForMandalaEvaluationComment from '@/components/view/NotificationCardForMandalaEvaluationComment.vue'
import NotificationCardForPathActivity from '@/components/view/NotificationCardForPathActivity.vue'
import NotificationCardForPathActivityComment from '@/components/view/NotificationCardForPathActivityComment.vue'
import NotificationLikeButton from '@/components/view/NotificationLikeButton.vue'
import NotificationTagMenu from '@/components/view/NotificationTagMenu.vue'
import ScrollNav from '@/components/parts/ScrollNav.vue'
import { format } from 'date-fns'
import { ja } from 'date-fns/locale'
import InfiniteLoading from 'vue-infinite-loading'
import SvgTextButton from '@/components/parts/SvgTextButton.vue'
import TextButton from '@/components/parts/TextButton.vue'
import scrollHide from '@/mixins/scrollHide'

const COMMENT_NOTIFICATION_TYPES = [
  'comment',
  'event_comment',
  'mandala_goal_self_evaluation_comment',
  'path_activity_comment',
]

export default {
  components: {
    NotificationCard,
    NotificationCardActions,
    NotificationCardForActivityResult,
    NotificationCardForComment,
    NotificationCardForEventComment,
    NotificationCardForMandalaEvaluation,
    NotificationCardForMandalaEvaluationComment,
    NotificationCardForPathActivity,
    NotificationCardForPathActivityComment,
    NotificationLikeButton,
    NotificationTagMenu,
    ScrollNav,
    SvgTextButton,
    TextButton,
    InfiniteLoading,
  },
  mixins: [scrollHide],
  data() {
    return {
      notifications: [],
      isLoadingInLocal: false,
      limit: 20,
      offset: 0,
      next: null,
      infiniteComplete: false,
      lockGoalOption: false,
      scrollTargetId: null,
      events: [],
      fetchedDates: new Set(),
      isNavigating: false,
      infiniteLoadingKey: 0,
      initialFetchedAt: null,
      showTagSettingsModal: false,
      isNavigatingToDestination: false,
      notificationDates: [],
      showDateNavigationBar: false,
    }
  },
  computed: {
    ...mapState('events', ['selectedCategories']),
    ...mapState('notifications', ['selectedTag1', 'selectedTag2', 'isTagFilterActive', 'isCommentFilterActive', 'returnNotificationId', 'returnNotificationDate']),
    ...mapGetters('auth', ['isManager']),
    hasNotifications() {
      return this.notifications.length > 0
    },
    hasNoTagFilterConditions() {
      return this.isTagFilterActive && this.selectedTag1.length === 0 && this.selectedTag2.length === 0
    },
    showEmptyText() {
      // infiniteHandlerの$state.complete()が呼ばれる前は表示しない
      if (!this.infiniteComplete) return false
      // complete()呼ばれた後に通知が0件であれば表示する
      if (this.isCommentFilterActive || this.isTagFilterActive) {
        return this.notificationsByDate.length === 0
      }
      return !this.hasNotifications
    },
    tagFilterParams() {
      if (!this.isTagFilterActive) return {}
      const params = {}
      if (this.selectedTag1.length > 0) {
        params.tag1__in = this.selectedTag1.join(',')
      }
      if (this.selectedTag2.length > 0) {
        params.tag2__in = this.selectedTag2.join(',')
      }
      return params
    },
    tagFilterArrayParams() {
      if (!this.isTagFilterActive) return {}
      const params = {}
      if (this.selectedTag1.length > 0) params.tag1__in = this.selectedTag1
      if (this.selectedTag2.length > 0) params.tag2__in = this.selectedTag2
      return params
    },
    commentFilterParams() {
      if (!this.isCommentFilterActive) return {}
      return { type__in: COMMENT_NOTIFICATION_TYPES.join(',') }
    },
    commentTypes() {
      if (!this.isCommentFilterActive) return []
      return COMMENT_NOTIFICATION_TYPES
    },
    eventById() {
      return this.events.reduce((prev, curr) => {
        return { ...prev, [curr.id]: curr }
      }, {})
    },
    notificationsByDate() {
      const groups = []
      let currentRawDate = null
      for (const notification of this.notifications) {
        const createdAt = new Date(notification.createdAt)
        const rawDate = format(createdAt, 'yyyy-MM-dd')
        const todayRaw = format(new Date(), 'yyyy-MM-dd')
        const dayOfWeek = format(createdAt, 'E', { locale: ja })
        const date =
          rawDate === todayRaw
            ? `今日(${dayOfWeek})`
            : format(createdAt, 'yyyy/MM/dd(E)', { locale: ja })
        if (rawDate !== currentRawDate) {
          currentRawDate = rawDate
          groups.push({ date, rawDate, notifications: [] })
        }
        groups[groups.length - 1].notifications.push(notification)
      }
      return groups
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isNavigatingToDestination) {
      this.$store.commit('notifications/clearReturnNotification')
      this.$store.commit('notifications/resetFilters')
    }
    this.isNavigatingToDestination = false
    next()
  },
  async created() {
    this.$store.commit('startLoading')
    this.lockGoalOption = await this.$axios
      .get('/tenants/')
      .then((res) => res.data.lockGoalOption)
      .catch(() =>
        this.$store.commit('notify/set', {
          isUnknownError: true,
          type: 'danger',
        }),
      )
    await this.fetchNotificationDates()
    this.$store.commit('finishLoading')
  },
  methods: {
    async infiniteHandler($state) {
      if (this.hasReturnNotification() && !this.initialFetchedAt) {
        this.initialFetchedAt = new Date().toISOString()
        await this.fetchReturnNotifications(this.returnNotificationDate)
        await this.scrollToReturnNotification()
        // offsetは既読操作などでnotifications.lengthと常に一致するとは限らないため、
        // 復帰範囲取得後だけ通常ページングの開始位置として同期する。
        this.offset = this.notifications.length
        $state.loaded()
        return
      }

      const res = await this.fetchNotifications()
      const existingIds = new Set(this.notifications.map((n) => n.id))
      const newResults = res.data.results.filter((n) => !existingIds.has(n.id))
      const newNotifications = [...this.notifications, ...newResults].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
      )

      const eventIds = newNotifications
        .map((notification) =>
          notification.type === 'event_comment'
            ? notification.eventComment.event
            : null,
        )
        .filter((id) => id !== null)
      const uniqEventIds = [...new Set(eventIds)]
      this.events = await Promise.all([
        ...uniqEventIds.map((id) => this.fetchEvent(id)),
      ])

      this.notifications = newNotifications
      this.updateDateNavigationBar()
      if (!this.initialFetchedAt) {
        this.initialFetchedAt = new Date().toISOString()
        if (this.hasReturnNotification()) {
          await this.scrollToReturnNotification()
        }
      }
      if (res.data.next) {
        this.next = res.data.next
        this.offset += this.limit
        $state.loaded()
      } else {
        $state.complete()
        this.infiniteComplete = true
      }
    },
    hasReturnNotification() {
      return !!(this.returnNotificationId && this.returnNotificationDate)
    },
    async scrollToReturnNotification() {
      if (!this.returnNotificationId) return
      await this.$nextTick()
      await new Promise((resolve) => setTimeout(resolve, 300))
      const continueRefs = this.$refs['continue-from-here-' + this.returnNotificationId]
      if (continueRefs && continueRefs[0]) {
        continueRefs[0].scrollIntoView({ behavior: 'smooth' })
      }
    },
    fetchNotifications() {
      const params = {
        order: '-created_at',
        limit: this.limit,
        offset: this.offset,
        ...this.commentFilterParams,
        ...this.tagFilterParams,
      }
      return this.$axios
        .get('/activities/notifications/', { params })
        .catch(() => {
          this.$store.commit('notify/set', {
            isUnknownError: true,
            type: 'danger',
          })
        })
    },
    fetchNotificationDates() {
      const params = {
        order: '-date',
        ...this.commentFilterParams,
        ...this.tagFilterParams,
      }
      return this.$axios
        .get('/activities/notifications/dates/', { params })
        .then((res) => {
          this.notificationDates = res.data.results
          this.updateDateNavigationBar()
        })
        .catch(() => {
          this.$store.commit('notify/set', {
            isUnknownError: true,
            type: 'danger',
          })
        })
    },
    updateDateNavigationBar() {
      this.showDateNavigationBar =
        this.notificationDates.length > 1 && this.notificationsByDate.length > 0
    },
    getNextNotificationDate(rawDate) {
      const index = this.notificationDates.indexOf(rawDate)
      if (index >= 0) return this.notificationDates[index + 1] ?? null
      return this.notificationDates.find((date) => date < rawDate) ?? null
    },
    fetchEvent(eventId) {
      return this.$axios.get(`/events/${eventId}/`).then((res) => res.data)
    },
    async updateEvent(eventId) {
      const event = await this.fetchEvent(eventId)
      const index = this.events.findIndex((event) => event.id === eventId)
      this.events.splice(index, 1, event)
    },
    async attendEvent(event) {
      this.$store.commit('startLoading')
      await this.$axios
        .post(`/events/${event.id}/attend/`)
        .then(() => {
          this.$store.commit('notify/set', {
            message: `${event.title}に参加します`,
          })
          this.updateEvent(event.id)
        })
        .catch((err) => {
          console.error(err)
          this.$store.commit('notify/set', {
            isUnknownError: true,
            type: 'danger',
          })
        })
      this.$store.commit('finishLoading')
    },
    async absenceEvent(event) {
      this.$store.commit('startLoading')
      await this.$axios
        .post(`/events/${event.id}/absence/`)
        .then(() => {
          this.$store.commit('notify/set', {
            message: `${event.title}に参加しません`,
          })
          this.updateEvent(event.id)
        })
        .catch((err) => {
          console.error(err)
          this.$store.commit('notify/set', {
            isUnknownError: true,
            type: 'danger',
          })
        })
      this.$store.commit('finishLoading')
    },
    async cancelAttendEvent(event) {
      this.$store.commit('startLoading')
      const isAttend = event.myReply?.isAttend
      await this.$axios
        .delete(`/events/${event.id}/attend/`)
        .then(() => {
          this.$store.commit('notify/set', {
            message: `${event.title}の${
              isAttend ? '参加' : '不参加'
            }をキャンセルしました`,
          })
          this.updateEvent(event.id)
        })
        .catch((err) => {
          console.error(err)
          this.$store.commit('notify/set', {
            isUnknownError: true,
            type: 'danger',
          })
        })
      this.$store.commit('finishLoading')
    },
    serializeParams(params) {
      const sp = new URLSearchParams()
      for (const [key, val] of Object.entries(params)) {
        if (Array.isArray(val)) {
          val.forEach((v) => sp.append(key, v))
        } else if (val != null) {
          sp.append(key, val)
        }
      }
      return sp.toString()
    },
    // 既読はスムーズに行うため、グローバルなローディングはいれない
    async onCheckRead(notificationId) {
      if (this.isLoadingInLocal) return
      this.isLoadingInLocal = true

      // 一番下の通知でなければ一つ下のnotificationに, 一番下なら次に一番下になるnotificationを指定, 最後の1件の通知の場合何もしない
      const globalIndex = this.notifications.findIndex(
        (n) => n.id === notificationId,
      )
      const checkedNotification = this.notifications[globalIndex]
      const checkedRawDate = checkedNotification?.createdAt.slice(0, 10)
      const scrollTargetIndex =
        this.notifications.length > globalIndex + 1
          ? globalIndex + 1
          : globalIndex - 1
      if (this.notifications.length > 1) {
        this.scrollTargetId = this.notifications.find(
          (item, idx) => idx === scrollTargetIndex,
        ).id
      }

      this.notifications = this.notifications.filter(
        (n) => n.id !== notificationId,
      )
      if (
        checkedRawDate &&
        !this.notifications.some((n) => n.createdAt.startsWith(checkedRawDate))
      ) {
        this.notificationDates = this.notificationDates.filter(
          (date) => date !== checkedRawDate,
        )
      }
      this.updateDateNavigationBar()

      await this.deleteNotification(notificationId).catch(() => {
        this.$store.commit('notify/set', {
          isUnknownError: true,
          type: 'danger',
        })
      })
      // ここでstoreのhasNotificationsを更新しないと既読にして通知が0になった場合でも通知用バッジが残ったままとなってしまう
      this.$store.commit('setHasNotifications', this.hasNotifications)

      this.isLoadingInLocal = false
    },
    async onClickDeleteNotificationsByDate(rawDate) {
      if (!window.confirm('通知内にあるこの日の全ての記録を既読にします。よろしいですか？')) return
      this.$store.commit('startLoading')
      const res = await this.$axios
        .delete('/activities/notifications/delete_all/', {
          params: {
            date: rawDate,
            before: this.initialFetchedAt,
            types: this.commentTypes,
            ...this.tagFilterArrayParams,
          },
          paramsSerializer: this.serializeParams,
        })
        .catch(() => {
          this.$store.commit('notify/set', { isUnknownError: true, type: 'danger' })
        })
      if (res) {
        this.notifications = this.notifications.filter((n) => !n.createdAt.startsWith(rawDate))
        this.notificationDates = this.notificationDates.filter((date) => date !== rawDate)
        this.updateDateNavigationBar()
        this.$store.commit('setHasNotifications', this.hasNotifications)
        await this.scrollToFirstNotificationAfterDate(rawDate)
      }
      this.$store.commit('finishLoading')
    },
    async onClickLikeAllByDate(rawDate) {
      if (!window.confirm('通知内にあるこの日のすべての記録にいいねが付きます。よろしいですか？')) return
      const res = await this.$axios
        .post('/activities/notifications/bulk_like/', {
          date: rawDate,
          before: this.initialFetchedAt,
          ...this.tagFilterArrayParams,
        })
        .catch(() => {
          this.$store.commit('notify/set', { isUnknownError: true, type: 'danger' })
        })
      if (!res) return
      await this.refetchNotificationsByDate(rawDate)
    },
    async refetchNotificationsByDate(rawDate) {
      const res = await this.$axios
        .get('/activities/notifications/', {
          params: {
            order: '-created_at',
            limit: 99999,
            created_at__gte: `${rawDate}T00:00:00`,
            created_at__lte: `${rawDate}T23:59:59`,
          },
        })
        .catch(() => {
          this.$store.commit('notify/set', { isUnknownError: true, type: 'danger' })
        })
      if (!res) return
      const updatedById = Object.fromEntries(res.data.results.map((n) => [n.id, n]))
      this.notifications = this.notifications.map((n) => updatedById[n.id] ?? n)
    },
    async onClickNotification(notification) {
      this.$store.commit('startLoading')

      if (notification.type === 'event_comment') {
        const event = this.eventById[notification.eventComment.event]
        if (!event) {
          this.$store.commit('notify/set', {
            type: 'danger',
            message: '予定が削除されたため、コメントを表示できません。',
          })
          this.$store.commit('finishLoading')
          return
        }

        // 予定のコメントが削除された場合、遷移せずに通知を削除
        const latestEvent = await this.fetchEvent(event.id)
        const isExistEventComment = latestEvent.eventComments.some(
          (comment) => comment.id === notification.eventComment.id,
        )
        if (!isExistEventComment) {
          // 通知の削除
          this.notifications = this.notifications.filter(
            (n) => n.id !== notification.id,
          )
          this.$store.commit('notify/set', {
            message:
              'このコメントは、コメントしたメンバーによって削除されています。',
          })
          this.$store.commit('finishLoading')
          return
        }

        const categoryId = event.category.id
        // 表示しようとしている予定が表示選択しているカテゴリにあるかを確認
        if (!this.selectedCategories.includes(categoryId)) {
          if (
            !window.confirm(
              'あなたが表示選択で設定していないカテゴリーの予定です。このカテゴリーを表示選択に追加し詳細画面に移動しますか？',
            )
          ) {
            this.$store.commit('finishLoading')
            return
          }
          this.$store.commit('events/setSelectedCategories', [
            ...this.selectedCategories,
            categoryId,
          ])
        }
      }

      const params = {}
      // 通知(コメント)
      if (notification.type === 'comment') {
        params.memberId = notification.comment.activityResult.createdBy
        params.goalId = notification.comment.activityResult.goal
        params.activityId = notification.comment.activityResult.id
        params.goalEndDate = format(
          new Date(notification.comment.activityResult.workAt),
          'yyyy-MM-dd',
        )
      }
      // 通知(活動記録)
      else if (notification.type === 'activity_result') {
        params.memberId = notification.activityResult.createdBy.id
        params.goalId = notification.activityResult.goal.id
        params.activityId = notification.activityResult.id
        params.goalEndDate = format(
          new Date(notification.activityResult.workAt),
          'yyyy-MM-dd',
        )
      }
      // 通知(予定)
      else if (notification.type === 'event_comment') {
        params.memberId = this.eventById[
          notification.eventComment.event
        ].createdBy.id
        params.eventId = notification.eventComment.event
        params.eventCommentId = notification.eventComment.id
      }
      // 自己評価提出
      else if (notification.type === 'mandala_goal_self_evaluation') {
        const { user, yearMonth } = notification.mandalaGoalSelfEvaluation
        params.memberId = user.id
        params.yearMonth = yearMonth
      }
      // 自己評価へのコメント
      else if (notification.type === 'mandala_goal_self_evaluation_comment') {
        const { mandalaGoalSelfEvaluationComment } = notification
        const {
          user,
          yearMonth,
        } = mandalaGoalSelfEvaluationComment.mandalaGoalSelfEvaluation
        params.memberId = user.id
        params.yearMonth = yearMonth
        params.commentId = mandalaGoalSelfEvaluationComment.id
      }
      // 進路活動記録
      else if (notification.type === 'path_activity') {
        params.memberId = notification.pathActivity.user.id
        params.pathActivityId = notification.pathActivity.id
      }
      // 進路活動記録のコメント
      else if (notification.type === 'path_activity_comment') {
        params.memberId = notification.pathActivityComment.user.id
        params.pathActivityCommentId = notification.pathActivityComment.id
      } else {
        this.$store.commit('notify/set', {
          isUnknownError: true,
          type: 'danger',
        })
        this.$store.commit('finishLoading')
        return
      }

      // ユーザーが表示できるかチェック
      const isUserIsValid = await this.validateActivityCreator(params.memberId)
      if (!isUserIsValid) {
        const recordName =
          notification.type === 'event_comment' ? '予定' : '活動記録'
        this.$store.commit('notify/set', {
          type: 'danger',
          message: `選択した${recordName}は該当のユーザーが利用停止等の理由で閲覧できなくなったため表示できません。`,
        })
        this.$store.commit('finishLoading')
        return
      }

      this.$store.commit('notifications/setReturnNotification', {
        id: notification.id,
        date: notification.createdAt.slice(0, 10),
      })
      this.isNavigatingToDestination = true

      if (['comment', 'activity_result'].includes(notification.type)) {
        this.$router.push(
          `/members/${params.memberId}?goalId=${params.goalId}&activityId=${params.activityId}&goalEndDate=${params.goalEndDate}&isOpenSelectedMember=true`,
        )
      } else if (notification.type === 'event_comment') {
        this.$router.push(
          `/events/?eventId=${params.eventId}&eventCommentId=${params.eventCommentId}&isOpenSelectedMember=true`,
        )
      } else if (notification.type === 'mandala_goal_self_evaluation') {
        this.$router.push(
          `/members/${params.memberId}/mandala_evaluation/?yearMonth=${params.yearMonth}&isOpenSelectedMember=true`,
        )
      } else if (notification.type === 'mandala_goal_self_evaluation_comment') {
        this.$router.push(
          `/members/${params.memberId}/mandala_evaluation/?yearMonth=${params.yearMonth}&scrollTo=${params.commentId}&isOpenSelectedMember=true`,
        )
      } else if (notification.type === 'path_activity') {
        this.$router.push(
          `/members/${params.memberId}/profile?pathActivityId=${params.pathActivityId}`,
        )
      } else if (notification.type === 'path_activity_comment') {
        this.$router.push(
          `/members/${params.memberId}/profile?pathActivityCommentId=${params.pathActivityCommentId}`,
        )
      }
      this.$store.commit('finishLoading')
    },
    // 通知に紐付く活動の作成者が有効かどうか(利用停止になっていないかorログインユーザーにとって閲覧対象か)を判定
    validateActivityCreator(memberId) {
      return this.$axios
        .get(`/users/${memberId}/`)
        .then(() => true)
        .catch((e) => {
          console.error(e)
          return false
        })
    },
    fetchGoal(goalId) {
      return this.$axios.get(`/goals/${goalId}/`)
    },
    deleteNotification(notificationId) {
      return this.$axios.delete(`/activities/notifications/${notificationId}/`)
    },
    async goalEndDate(notification, goalId) {
      if (notification.type === 'activity_result') {
        return notification.activityResult.goal.endDate
      } else {
        const goal = await this.fetchGoal(goalId)
        return goal.data.endDate
      }
    },
    async onLike(activityId) {
      const res = await this.$axios
        .post(`/activities/activity_results/${activityId}/like/`)
        .catch(() => {
          this.$store.commit('notify/set', {
            isUnknownError: true,
            type: 'danger',
          })
        })
      if (!res) return
      this.updateNotificationLiked(activityId, true)
    },
    async onDislike(activityId) {
      const res = await this.$axios
        .post(`/activities/activity_results/${activityId}/dislike/`)
        .catch(() => {
          this.$store.commit('notify/set', {
            isUnknownError: true,
            type: 'danger',
          })
        })
      if (!res) return
      this.updateNotificationLiked(activityId, false)
    },
    updateNotificationLiked(activityId, liked) {
      this.notifications = this.notifications.map((n) => {
        if (n.activityResult?.id !== activityId) return n
        return { ...n, activityResult: { ...n.activityResult, liked } }
      })
    },
    fetchPathActivity(pathActivityId) {
      return this.$axios.get(`/profiles/path-activities/${pathActivityId}/`)
    },
    getCurrentGroupIndex(threshold = 0) {
      for (let i = this.notificationsByDate.length - 1; i >= 0; i--) {
        const el = this.$refs['group-' + i]?.[0]
        if (el && el.getBoundingClientRect().top <= threshold) {
          return i
        }
      }
      return 0
    },
    async goToPrevDate() {
      if (this.isNavigating) return
      this.isNavigating = true
      try {
        const target = this.getCurrentGroupIndex(-1)
        const todayRaw = format(new Date(), 'yyyy-MM-dd')
        if (this.notificationsByDate[target]?.rawDate === todayRaw) {
          this.fetchedDates.delete(todayRaw)
          await this.fetchNotificationsByDate(todayRaw)
          await this.$nextTick()
        }
        this.$refs['group-' + target]?.[0]?.scrollIntoView({
          behavior: 'smooth',
        })
      } finally {
        setTimeout(() => {
          this.isNavigating = false
        }, 600)
      }
    },
    async goToNextDate() {
      if (this.isNavigating) return
      this.isNavigating = true
      try {
        const currentIndex = this.getCurrentGroupIndex(1)
        const currentGroup = this.notificationsByDate[currentIndex]
        if (!currentGroup) return
        const nextRawDate = this.getNextNotificationDate(currentGroup.rawDate)
        if (!nextRawDate) {
          this.infiniteComplete = true
          return
        }
        const oldestNotification = this.notifications[this.notifications.length - 1]
        try {
          this.$store.commit('startLoading')
          await this.fetchNotificationsByDate(nextRawDate, oldestNotification.createdAt)
        } finally {
          this.$store.commit('finishLoading')
        }
        await this.$nextTick()
        const target = this.notificationsByDate.findIndex(
          (group) => group.rawDate === nextRawDate,
        )
        if (target < 0) return
        this.$refs['group-' + target]?.[0]?.scrollIntoView({
          behavior: 'smooth',
        })
      } finally {
        setTimeout(() => {
          this.isNavigating = false
        }, 600)
      }
    },
    async fetchNextDateGroup(currentLastRawDate) {
      const nextRawDate = this.getNextNotificationDate(currentLastRawDate)
      if (!nextRawDate) {
        this.infiniteComplete = true
        return
      }
      await this.fetchNotificationsByDate(nextRawDate)
    },
    async fetchNotificationsByDate(rawDate, createdAtLte) {
      if (this.fetchedDates.has(rawDate)) return
      this.fetchedDates.add(rawDate)
      const res = await this.$axios
        .get('/activities/notifications/', {
          params: {
            order: '-created_at',
            limit: 99999,
            created_at__gte: `${rawDate}T00:00:00`,
            created_at__lte: createdAtLte || `${rawDate}T23:59:59`,
            ...this.commentFilterParams,
            ...this.tagFilterParams,
          },
        })
        .catch(() => {
          this.$store.commit('notify/set', {
            isUnknownError: true,
            type: 'danger',
          })
        })
      if (!res) return
      const existingIds = new Set(this.notifications.map((n) => n.id))
      const newNotifications = res.data.results.filter(
        (n) => !existingIds.has(n.id),
      )
      if (newNotifications.length === 0) return
      await this.mergeNewNotifications(newNotifications)
      this.updateDateNavigationBar()
    },
    async fetchReturnNotifications(rawDate) {
      const res = await this.$axios
        .get('/activities/notifications/', {
          params: {
            order: '-created_at',
            limit: 99999,
            created_at__gte: `${rawDate}T00:00:00`,
            created_at__lte: this.initialFetchedAt,
            ...this.commentFilterParams,
            ...this.tagFilterParams,
          },
        })
        .catch(() => {
          this.$store.commit('notify/set', {
            isUnknownError: true,
            type: 'danger',
          })
        })
      if (!res) return
      const existingIds = new Set(this.notifications.map((n) => n.id))
      const newNotifications = res.data.results.filter(
        (n) => !existingIds.has(n.id),
      )
      if (newNotifications.length === 0) return
      await this.mergeNewNotifications(newNotifications)
      this.updateDateNavigationBar()
    },
    async mergeNewNotifications(newNotifications) {
      const newEventIds = newNotifications
        .map((n) => n.type === 'event_comment' ? n.eventComment.event : null)
        .filter((id) => id !== null && !this.eventById[id])
      const uniqNewEventIds = [...new Set(newEventIds)]
      if (uniqNewEventIds.length > 0) {
        const newEvents = await Promise.all(
          uniqNewEventIds.map((id) => this.fetchEvent(id)),
        )
        this.events = [...this.events, ...newEvents]
      }
      this.notifications = [...this.notifications, ...newNotifications].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
      )
    },
    getFirstDateGroupIndexAfterDate(rawDate) {
      return this.notificationsByDate.findIndex(
        (group) => group.rawDate < rawDate,
      )
    },
    scrollToNotification(notificationId, options = {}) {
      const targetRef = this.$refs[notificationId]
      if (!targetRef) return false
      targetRef[0].$el.scrollIntoView(options)
      return true
    },
    scrollToDateGroup(groupIndex, options = {}) {
      const targetRef = this.$refs['group-' + groupIndex]
      if (!targetRef) return false
      targetRef[0].scrollIntoView(options)
      return true
    },
    async scrollToFirstNotificationAfterDate(rawDate) {
      await this.$nextTick()
      let targetIndex = this.getFirstDateGroupIndexAfterDate(rawDate)
      if (targetIndex < 0 && !this.infiniteComplete) {
        await this.fetchNextDateGroup(rawDate)
        await this.$nextTick()
        targetIndex = this.getFirstDateGroupIndexAfterDate(rawDate)
      }
      if (targetIndex >= 0) {
        this.scrollToDateGroup(targetIndex, { behavior: 'smooth' })
      }
    },
    scrollToNextNotification() {
      if (this.scrollTargetId && this.scrollToNotification(this.scrollTargetId)) {
        this.scrollTargetId = null
      }
    },
    toggleCommentFilter() {
      this.$store.commit('notifications/setIsCommentFilterActive', !this.isCommentFilterActive)
      this.resetAndReload()
    },
    isCommentNotificationType(type) {
      return COMMENT_NOTIFICATION_TYPES.includes(type)
    },
    openTagSettings() {
      this.showTagSettingsModal = !this.showTagSettingsModal
    },
    onTagMenuSave({ tag1, tag2 }) {
      this.$store.commit('notifications/setSelectedTag1', tag1)
      this.$store.commit('notifications/setSelectedTag2', tag2)
      this.showTagSettingsModal = false
      if (this.isTagFilterActive) {
        this.resetAndReload()
      }
    },
    toggleTagFilter() {
      this.$store.commit('notifications/setIsTagFilterActive', !this.isTagFilterActive)
      this.resetAndReload()
    },
    resetAndReload() {
      this.notifications = []
      this.offset = 0
      this.infiniteComplete = false
      this.fetchedDates = new Set()
      this.events = []
      this.initialFetchedAt = null
      this.notificationDates = []
      this.showDateNavigationBar = false
      this.infiniteLoadingKey++
      this.fetchNotificationDates()
    },
  },
}
</script>

<style lang="scss" scoped>
.notifications {
  padding-bottom: 128px !important;
  &__date-group-header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0 8px 0;
  }
  &__date-label {
    font-size: $fs-nm;
    font-weight: bold;
    text-align: center;
  }
  &__date-actions {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 16px;
    @media (max-width: 575px) {
      padding-right: 32px;
    }
  }
  &__divider {
    border: none;
    border-top: solid 1px $grey03;
    margin: 12px 0;
  }
  &__btn-wrapper {
    padding: 16px 0;
    position: sticky;
    bottom: calc(env(safe-area-inset-bottom) + 80px);
    display: flex;
    justify-content: flex-end;
  }
  &__btn {
    box-shadow: 1px 1px 6px 0 $grey05;
    border-radius: 6px;
    border: 2px solid $l-blue;
    padding: 5px 10px;
    font-size: $fs-s;
    line-height: normal;
  }
  &__btn--like-all {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0;
    box-shadow: 1px 1px 6px 0 $grey05;
  }
  &__btn-label {
    font-size: 10px;
    line-height: 1;
    margin-top: 2px;
  }
  &__filter-btns {
    position: fixed;
    bottom: calc(env(safe-area-inset-bottom) + 90px);
    left: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    z-index: 100;
    transition: opacity 0.3s, visibility 0.3s;
    @media (min-width: 992px) {
      left: calc(120px + (100vw - 120px - 800px) / 2 + 16px);
    }
    &--hidden {
      opacity: 0;
      visibility: hidden;
    }
  }
  &__comment-filter-btn,
  &__tag-filter-btn {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 5px 10px;
    border-radius: 6px;
    border: 2px solid $l-blue;
    background-color: $l-blue;
    color: $white;
    font-size: $fs-s;
    font-weight: bold;
    box-shadow: 1px 2px 6px 0 $grey05;
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s, border-color 0.2s;
  }
  &__comment-filter-btn--active,
  &__tag-filter-btn--active {
    background-color: $blue;
    border-color: $blue;
  }
  &__comment-filter-btn-icon {
    font-size: 16px;
  }
  &__tag-tune-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    color: $l-blue;
    border: none;
    box-shadow: 1px 2px 6px 0 $grey05;
    cursor: pointer;
    &--active {
      color: $white;
      background-color: $blue;
    }
  }
  &__tag-settings-btn-icon {
    font-size: 20px;
  }
  &__no-filter-conditions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 100px 16px 0 16px;
    margin: 16px 0;
    border-radius: 12px;
    font-size: $fs-m;
    line-height: 2;
  }
  &__icon {
    display: inline-block;
    vertical-align: middle;
  }
  &__item {
    border: solid 1px $grey10;
    border-radius: 8px;
    background-color: $white;
  }
  &__heading {
    font-size: $fs-nm;
    font-weight: bold;
    position: relative;
    padding-left: 16px;
    &:before {
      content: "";
      position: absolute;
      background: $grey16;
      top: 4px;
      left: 0;
      height: 12px;
      width: 12px;
      border-radius: 50%;
    }
    &--marked {
      &:before {
        background: $pink;
      }
    }
  }
  &__box {
    text-align: right;
  }
  &__count {
    font-size: $fs-m;
    color: $l-blue;
    font-weight: bold;
  }
  &__date {
    font-size: $fs-s;
  }
  &__body {
    border-top: solid 1px $grey10;
  }
  &__check {
    box-sizing: border-box;
    cursor: pointer;
    display: inline-block;
    position: relative;
    width: auto;
    &:before {
      background: #fff;
      border: 1px solid $grey05;
      content: "";
      display: block;
      height: 26px;
      margin-top: -10px;
      position: absolute;
      top: 50%;
      width: 26px;
      border-radius: 4px;
      right: 0;
    }
    &:after {
      border-right: 4px solid $l-blue;
      border-bottom: 4px solid $l-blue;
      content: "";
      display: block;
      height: 16px;
      margin-top: -7px;
      opacity: 0;
      position: absolute;
      top: 50%;
      transform: rotate(45deg);
      width: 10px;
      border-radius: 2px;
      right: 7px;
    }
  }
}

input[type="checkbox"] {
  display: none;
}

input[type="checkbox"]:checked + .notifications__check::after {
  opacity: 1;
}

.comment {
  &__img {
    width: 30px;
    height: 30px;
    object-fit: cover;
  }
  &__name {
    font-weight: bold;
    font-size: $fs-m;
  }
  &__date {
    font-size: $fs-m;
  }
  &__body {
    color: $grey04;
  }
}

.notification-card-enter-active,
.notification-card-leave-active {
  transition: opacity 0.2s;
}

.notification-card-enter,
.notification-card-leave-to {
  opacity: 0;
}

.notifications__continue-from-here {
  font-size: $fs-s;
  font-weight: bold;
  padding: 8px 0;
}
</style>
